import { useEffect, useRef, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const POLL_MS = 5000;

export const SOUND_KEY = "ct_admin_sound";
export const soundOn = () => localStorage.getItem(SOUND_KEY) !== "off";

export function playPling() {
  if (!soundOn()) return;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    const ctx = new Ctx();
    const notes = [880, 1320];
    notes.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      const t = ctx.currentTime + i * 0.12;
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.18, t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.35);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t);
      osc.stop(t + 0.4);
    });
    setTimeout(() => ctx.close(), 1000);
  } catch (_) {}
}

export default function useChatUnread(token, onUnauthorized) {
  const [count, setCount] = useState(0);
  const prev = useRef(null);

  useEffect(() => {
    if (!token) return;
    let stop = false;
    const tick = async () => {
      try {
        const res = await fetch(`${API}/api/admin/chat/unread`, { headers: { Authorization: `Bearer ${token}` } });
        if (res.status === 401) return onUnauthorized?.();
        const d = await res.json();
        if (stop) return;
        if (prev.current !== null && d.count > prev.current) playPling();
        prev.current = d.count;
        setCount(d.count);
      } catch (_) {}
    };
    tick();
    const t = setInterval(tick, POLL_MS);
    return () => { stop = true; clearInterval(t); };
  }, [token, onUnauthorized]);

  useEffect(() => {
    const base = "Admin – City Trafikskola";
    document.title = count > 0 ? `(${count}) ${base}` : base;
    return () => { document.title = base; };
  }, [count]);

  return count;
}
